module.exports = __webpack_public_path__ + "img/deeplink_step3.8960e852.svg";